module.exports = __webpack_public_path__ + "static/ssp-7207e2e60393472bfa7d29109af17eda.png";